<script setup>
import { RouterView } from 'vue-router';
import { useCommonStore } from '@/stores/common';
import { ref } from 'vue';
import PageFooter from './components/page_navigation/PageFooter.vue';
import PageNavigation from './components/page_navigation/PageNavigation.vue';
import BookACallIcon from './components/BookACallIcon.vue';
import CookieSelectBanner from './components/CookieSelectBanner.vue';

const store = useCommonStore();
const usePageNavigation = ref(store.usePageNavigation());

</script>

<template>
  <PageNavigation v-if="usePageNavigation"></PageNavigation>
  <div>
    <RouterView />
  </div>
  <PageFooter></PageFooter>
  <BookACallIcon></BookACallIcon>
  <CookieSelectBanner></CookieSelectBanner>
</template>

<style lang="css" scoped></style>